import React from 'react';
import styles from './companySettings.module.scss';
import {
    Route,
    Switch,
    Redirect,
    NavLink
} from 'react-router-dom';
import General from './general';
import Integrations from './integrations';
import HRISIntegration from './hrisIntegration';
import CustomNavbar from '../customNavbar';


const CompanySettings = (props) => {
    const breadcrumb = [
        {
            pathaddress: '',
            pathname: 'Company Settings',
            isActive: true,
            key: 1 + 'Company Settings'
        }
    ];

    let main_props = {
        permissions: props.permissions,
        role: props.role,
        toggleInterviewView: props.toggleInterviewView
    }

    return (
        <div className={styles.settingsBodyContainer}>
            <div className={styles.backgroundFixedComponents}>
                <CustomNavbar history={props.mainHistory} breadcrumbArray={breadcrumb} />

            </div>
            <div className={styles.companySettingsBodyWrapper}>
                <ul className={styles.tabOptionsContainer}>
                    <NavLink to="/app/company/settings/general" id="settings_genaral_nav" activeClassName={styles.subCategoryContainerActive} className={styles.subCategoryContainer}>
                        <li className={styles.switchActive}> <p className={styles.settingsContentSwitch}>General</p></li>
                    </NavLink>
                    <NavLink to="/app/company/settings/integrations" id="settings_intergrations_nav" activeClassName={styles.subCategoryContainerActive} className={styles.subCategoryContainer}>
                        <li className={styles.switchActive}><p className={styles.settingsContentSwitch}>Integrations</p></li>
                    </NavLink>
                    <NavLink to="/app/company/settings/hris" id="settings_hris_nav" activeClassName={styles.subCategoryContainerActive} className={styles.subCategoryContainer}>
                        <li className={styles.switchActive}><p className={styles.settingsContentSwitch}>HRIS Integrations</p></li>
                    </NavLink>
                </ul>
                <Switch>
                    <Route path='/app/company/settings/general' exac={true} render={props => <General main_props={main_props}  {...props} />} />
                    <Route path='/app/company/settings/integrations' exac={true} render={props => <Integrations main_props={main_props} {...props} />} />
                    <Route path='/app/company/settings/hris' exac={true} render={props => <HRISIntegration main_props={main_props} {...props} />} />
                    <Redirect from="/" to="/app/company/settings/general" />
                </Switch>
            </div>
        </div >
    )
}

export default CompanySettings;